export const SET_WGT_THRESHOLD_API = 'SetWeightThreshold';
export const SET_WGT_THRESHOLDS_API = 'SetWeightThresholds';
export const UPDATE_WGT_RECORDS_API = 'UpdateWeightAlertRecords';
export const SET_WGT_RECORDS_TO_DEFAULT_API = 'SetWeightAlertRecordsToDefault';
export const CLOSE_ALERTS_API = 'CloseAlertRecords';
export const CLEAN_WGT_RECORDS_API = 'CleanWeightAlertRecords';
